import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Gift, Utensils } from 'lucide-react';

export default function ArtikelEidRezepteKinder() {
  return (
    <main className="pt-20 md:pt-24 bg-[#FDFCF8]">
      <section className="py-16 md:py-24 bg-[#4A5D4F]">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <Link to="/ratgeber" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 transition-colors"><ArrowLeft className="w-4 h-4" />Alle Ratgeber</Link>
          <div className="flex items-center gap-2 text-[#D4C5A9] text-sm mb-4"><Calendar className="w-4 h-4" /><span>Februar 2026</span></div>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-white mb-6 leading-tight">Kinderfreundliche Eid Rezepte: Süßes & Herzhaftes</h1>
          <p className="text-lg text-white/80 leading-relaxed">Einfache Rezepte, die Kinder lieben und bei denen sie mithelfen können.</p>
        </div>
      </section>
      <article className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12 prose prose-lg max-w-none">
          <p className="text-xl text-[#2C332E] leading-relaxed mb-8">Gemeinsames Kochen zu Eid schafft wertvolle Erinnerungen. Diese Rezepte sind nicht nur lecker, sondern auch kindgerecht – einfach zuzubereiten und perfekt zum Mithelfen!</p>

          <section className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#D4C5A9]/30 flex items-center justify-center"><Utensils className="w-6 h-6 text-[#4A5D4F]" /></div>
              <h2 className="font-serif text-2xl font-medium text-[#2C332E]">Süße Rezepte</h2>
            </div>

            <div className="space-y-6">
              <div className="bg-[#F5F5F0] rounded-xl p-6">
                <h4 className="font-medium text-[#2C332E] mb-3">🌙 Mond-Kekse</h4>
                <p className="text-sm text-[#4B5563] mb-3">Kinder lieben es, Kekse auszustechen!</p>
                <div className="bg-white rounded-lg p-4">
                  <p className="text-sm font-medium text-[#2C332E] mb-2">Zutaten:</p>
                  <ul className="text-sm text-[#4B5563] space-y-1 mb-3">
                    <li>• 250g Mehl</li>
                    <li>• 125g Butter (weich)</li>
                    <li>• 100g Zucker</li>
                    <li>• 1 Ei</li>
                    <li>• 1 TL Vanille</li>
                    <li>• Zuckerguss & Streusel zum Verzieren</li>
                  </ul>
                  <p className="text-sm font-medium text-[#2C332E] mb-2">So geht's:</p>
                  <p className="text-sm text-[#4B5563]">1. Alle Zutaten verkneten. 2. Teig 30 Min. kühlen. 3. Ausrollen & Monde/Sterne ausstechen. 4. Bei 180°C ca. 10 Min. backen. 5. Auskühlen lassen & verzieren!</p>
                </div>
                <p className="text-sm text-[#4A5D4F] mt-3">👶 Kinder können: Teig kneten, ausstechen, verzieren</p>
              </div>

              <div className="bg-[#F5F5F0] rounded-xl p-6">
                <h4 className="font-medium text-[#2C332E] mb-3">🍫 Dattel-Schoko-Bällchen</h4>
                <p className="text-sm text-[#4B5563] mb-3">Gesund, lecker und ohne Backen!</p>
                <div className="bg-white rounded-lg p-4">
                  <p className="text-sm font-medium text-[#2C332E] mb-2">Zutaten:</p>
                  <ul className="text-sm text-[#4B5563] space-y-1 mb-3">
                    <li>• 200g entkernte Datteln</li>
                    <li>• 50g gemahlene Mandeln</li>
                    <li>• 2 EL Kakao</li>
                    <li>• Kokosraspeln</li>
                  </ul>
                  <p className="text-sm font-medium text-[#2C332E] mb-2">So geht's:</p>
                  <p className="text-sm text-[#4B5563]">1. Datteln im Mixer zerkleinern. 2. Mit Mandeln & Kakao mischen. 3. Kleine Kugeln rollen. 4. In Kokos wälzen!</p>
                </div>
                <p className="text-sm text-[#4A5D4F] mt-3">👶 Kinder können: Kugeln rollen, in Kokos wälzen</p>
              </div>

              <div className="bg-[#F5F5F0] rounded-xl p-6">
                <h4 className="font-medium text-[#2C332E] mb-3">🧁 Eid Cupcakes</h4>
                <p className="text-sm text-[#4B5563] mb-3">Bunte Cupcakes mit Mond-Dekoration.</p>
                <div className="bg-white rounded-lg p-4">
                  <p className="text-sm text-[#4B5563]">Backmischung verwenden und mit selbstgemachtem Frosting verzieren. Monde und Sterne aus Fondant oder als Zuckerstreusel obendrauf!</p>
                </div>
                <p className="text-sm text-[#4A5D4F] mt-3">👶 Kinder können: Teig rühren, Förmchen füllen, dekorieren</p>
              </div>

              <div className="bg-[#F5F5F0] rounded-xl p-6">
                <h4 className="font-medium text-[#2C332E] mb-3">🍨 Dattel-Milchshake</h4>
                <p className="text-sm text-[#4B5563] mb-3">Natürlich süß und erfrischend.</p>
                <div className="bg-white rounded-lg p-4">
                  <p className="text-sm font-medium text-[#2C332E] mb-2">Zutaten:</p>
                  <ul className="text-sm text-[#4B5563] space-y-1">
                    <li>• 5 entkernte Datteln</li>
                    <li>• 300ml Milch</li>
                    <li>• 1 Kugel Vanilleeis</li>
                    <li>• Prise Zimt</li>
                  </ul>
                  <p className="text-sm text-[#4B5563] mt-2">Alles mixen – fertig!</p>
                </div>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#4A5D4F]/10 flex items-center justify-center"><Utensils className="w-6 h-6 text-[#4A5D4F]" /></div>
              <h2 className="font-serif text-2xl font-medium text-[#2C332E]">Herzhafte Rezepte</h2>
            </div>

            <div className="space-y-6">
              <div className="bg-[#F5F5F0] rounded-xl p-6">
                <h4 className="font-medium text-[#2C332E] mb-3">🥟 Mini-Samosas</h4>
                <p className="text-sm text-[#4B5563] mb-3">Kleine Teigtaschen – perfekt zum Dippen!</p>
                <div className="bg-white rounded-lg p-4">
                  <p className="text-sm text-[#4B5563]">Fertige Teigblätter (Yufka) mit einer Füllung aus Kartoffeln & Erbsen füllen, zu Dreiecken falten und im Ofen knusprig backen. Kinder lieben das Falten!</p>
                </div>
                <p className="text-sm text-[#4A5D4F] mt-3">👶 Kinder können: Füllung einfüllen, falten</p>
              </div>

              <div className="bg-[#F5F5F0] rounded-xl p-6">
                <h4 className="font-medium text-[#2C332E] mb-3">🍕 Mini-Pide</h4>
                <p className="text-sm text-[#4B5563] mb-3">Türkische Pizza in Kinderhand-Größe.</p>
                <div className="bg-white rounded-lg p-4">
                  <p className="text-sm text-[#4B5563]">Fertigen Pizzateig in kleine Ovale formen, mit Käse & Hackfleisch (halal) belegen, Ränder einschlagen und backen.</p>
                </div>
                <p className="text-sm text-[#4A5D4F] mt-3">👶 Kinder können: Teig formen, belegen</p>
              </div>

              <div className="bg-[#F5F5F0] rounded-xl p-6">
                <h4 className="font-medium text-[#2C332E] mb-3">🧀 Käse-Börek-Sticks</h4>
                <p className="text-sm text-[#4B5563] mb-3">Knusprige Stangen zum Snacken.</p>
                <div className="bg-white rounded-lg p-4">
                  <p className="text-sm text-[#4B5563]">Yufka-Teig in Streifen schneiden, mit Fetakäse bestreichen, aufrollen und backen bis sie goldbraun sind.</p>
                </div>
                <p className="text-sm text-[#4A5D4F] mt-3">👶 Kinder können: Rollen, mit Ei bestreichen</p>
              </div>

              <div className="bg-[#F5F5F0] rounded-xl p-6">
                <h4 className="font-medium text-[#2C332E] mb-3">🍗 Hähnchen-Nuggets (selbstgemacht)</h4>
                <p className="text-sm text-[#4B5563] mb-3">Halal und viel besser als gekauft!</p>
                <div className="bg-white rounded-lg p-4">
                  <p className="text-sm text-[#4B5563]">Halal-Hähnchenbrust in Stücke schneiden, in Mehl-Ei-Paniermehl wenden und im Ofen knusprig backen. Dazu Ketchup oder Joghurt-Dip!</p>
                </div>
                <p className="text-sm text-[#4A5D4F] mt-3">👶 Kinder können: Panieren (mit sauberen Händen!)</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Tipps zum Kochen mit Kindern</h2>
            <div className="bg-[#4A5D4F]/10 rounded-xl p-6">
              <ul className="text-[#4B5563] space-y-3">
                <li><strong>Vorbereitung:</strong> Zutaten vorher abmessen und bereitstellen</li>
                <li><strong>Altersgerecht:</strong> Einfache Aufgaben wie Rühren, Kneten, Verzieren</li>
                <li><strong>Sicherheit:</strong> Heiße Dinge nur Erwachsene handhaben lassen</li>
                <li><strong>Geduld:</strong> Es dauert länger und wird chaotischer – das ist okay!</li>
                <li><strong>Spaß:</strong> Es geht um gemeinsame Zeit, nicht um Perfektion</li>
              </ul>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Fazit</h2>
            <p className="text-[#4B5563] leading-relaxed mb-4">Gemeinsames Kochen zu Eid schafft Erinnerungen, die ein Leben lang bleiben. Diese Rezepte sind einfach genug für kleine Hände und lecker genug für die ganze Familie!</p>
            <p className="text-xl text-[#4A5D4F] font-medium">Eid Mubarak! 🌙</p>
          </section>

          <div className="bg-[#F5F5F0] rounded-2xl p-6 mb-8">
            <h3 className="font-serif text-lg font-medium text-[#2C332E] mb-4">Weitere Artikel</h3>
            <ul className="space-y-2">
              <li><Link to="/ratgeber/eid-suessigkeiten-rezepte" className="text-[#4A5D4F] hover:underline">→ 15 beliebte Eid Süßigkeiten Rezepte</Link></li>
              <li><Link to="/ratgeber/ramadan-iftar-rezepte" className="text-[#4A5D4F] hover:underline">→ Ramadan Iftar Rezepte</Link></li>
            </ul>
          </div>

          <div className="bg-[#4A5D4F] rounded-2xl p-8 text-center">
            <h3 className="font-serif text-2xl font-medium text-white mb-4">Kinderprodukte entdecken</h3>
            <Link to="/geschenke/kinder" className="inline-flex items-center gap-2 bg-white text-[#4A5D4F] px-8 py-3 rounded-full font-medium hover:bg-[#D4C5A9] transition-colors">Jetzt stöbern<Gift className="w-5 h-5" /></Link>
          </div>
        </div>
      </article>
    </main>
  );
}
